module.exports = __webpack_public_path__ + "img/7F8A7C554C83A2C1.ce1e63c1.png";